import AmortizationInputLibrary from '../../components/amortization-calculator/input-library';
import HomeAffordabilityInputLibrary from '../../components/home-affordability-calculator/input-library';
import MortgageInputLibrary from '../../components/mortgage-calculator/shared/input-library';
import RefinanceInputLibrary from '../../components/refinance-calculator/input-library';
import RentVsBuyInputLibrary from '../../components/rentvsbuy-calculator/control-panel/shared/input-library';
import CostOfLivingLibrary from '../../components/cost-of-living-calculator/compare-cities/input-library';

import { Field } from './inputs';

export type ValidationLibrary =
  | typeof RefinanceInputLibrary
  | typeof HomeAffordabilityInputLibrary
  | typeof AmortizationInputLibrary
  | typeof MortgageInputLibrary
  | typeof RentVsBuyInputLibrary
  | typeof CostOfLivingLibrary;

export type ValidationObject =
  | { valid: true; message?: never }
  | { valid: false; message: string };

export function validateField(
  fieldName: Field,
  value: any,
  inputLibrary: ValidationLibrary,
  additionalInputIdsToValidate: Array<Field>
): ValidationObject {
  if (!inputLibrary?.[fieldName]?.validators) return { valid: true };

  const inputs = additionalInputIdsToValidate
    ? additionalInputIdsToValidate
        .map((input) => inputLibrary[input])
        .concat(inputLibrary[fieldName])
    : [inputLibrary[fieldName]] || [];

  let response: ValidationObject;

  inputs.map((input) => {
    const validatorsArray = input?.validators;
    for (let i = 0; i < validatorsArray.length; i += 1) {
      const validationFunc = validatorsArray[i];
      const payload = { [fieldName]: value };

      response = validationFunc(payload, input);
      const valid = response?.valid;

      // return first validation that failed
      if (!valid) return response;
    }
    return null;
  });

  return response;
}
